<template>
	<div class="cell-wrapper">{{ sanitized }}{{ (sanitized || '').length >= 160 ? '...' : '' }}</div>
</template>

<script>

export default {

	props: [ 'row', 'field' ],

	computed: {

		sanitized() {
			const div = document.createElement('div');
			div.innerHTML = (this.row[ this.field.slug ] || '').replace(/\n/g, ' ');
			return (div.textContent || div.innerText || '').slice(0,160);
		},

	},
};
</script>
